import React, { useState } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { PopupMenu, gray, salmon, blue } from 'quantux-ui';

const PracticeUserCard = (props) => {
  const [isAccessTypeMenuOpen, toggleAccessTypeMenu] = useState(false);

  const styles = StyleSheet.create({
    practiceUserMenuContainer: {
      minWidth: '140px'
    },
    practiceUserMenuItem: {
      display: 'flex',
      alignItems: 'center',
      height: '32px',
      width: '138px',
      paddingLeft: '8px',
      background: '#103A60',
      cursor: 'pointer',
      ':hover': {
        background: gray[800]
      }
    },
    practiceUserMenuItemActive: {
      display: 'flex',
      alignItems: 'center',
      height: '32px',
      width: '138px',
      paddingLeft: '8px',
      background: gray[800],
      color: 'white',
      ':hover': {
        background: gray[800],
        color: 'white'
      }
    },
    practiceOwnerRemoveBtn: {
      fontSize: '20px',
      ':hover': {
        color: salmon[500]
      }
    },
    practiceOwnerCard: {
      marginBottom: '8px',
      background: '#0A3250',
      borderRadius: '5px',
      padding: '8px'
    },
    practiceOwnerCardTopSection: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  });

  const accessTypeMenu = React.createRef();

  const {
    el,
    removePracticeOwner,
    updateAccessType
  } = props;

  const idt = el.id ? el.id : el.user;

  return (
    <div className={css(styles.practiceOwnerCard)}>
      <div className={css(styles.practiceOwnerCardTopSection)}>
        <div className='fx'>
          <img
            src={el.avatarImageUrl}
            alt='practice owner avatar image url'
            style={{
              maxHeight: '32px'
            }}
          />
          <div style={{ marginTop: '-2px', marginLeft: '8px' }}>
            <div style={{ fontSize: '12px' }}>{el.fullName}</div>
            <div style={{ fontSize: '12px' }}>
              {`NPI: ${(+(el.npi) === 0) ? 'N/A' : el.npi}`}
            </div>
          </div>
        </div>
        {/* Close button */}
        <i
          className={`fa fa-trash ${css(styles.practiceOwnerRemoveBtn)}`}
          onClick={() => { removePracticeOwner(idt); }}
        />
      </div>
      <div
        style={{
          position: 'relative',
          display: props.disableMemberTypeSelection ? 'none' : ''
        }}
        ref={accessTypeMenu}
      >
        <div
          className='fx'
          onClick={() => {
            if (!props.disableMemberTypeSelection) {
              toggleAccessTypeMenu(!isAccessTypeMenuOpen);
            }
          }}
        >
          <div style={{ cursor: 'pointer' }}>
            Access Type: <span style={{ color: blue[500] }}>{el.accessType}</span>
          </div>
          <div
            className='ml-1'
            style={{
              color: blue[500],
              display: props.disableMemberTypeSelection ? 'none' : ''
            }}
          >
            <i className={`fa fa-lg ${isAccessTypeMenuOpen ? 'fa-caret-up' : 'fa-caret-down'}`} />
          </div>
        </div>
        {/* User Access Type PopupMenu */}
        <PopupMenu
          top={23}
          right={8}
          zIndex='1550'
          position="absolute"
          visible={isAccessTypeMenuOpen}
          parent={accessTypeMenu}
          onOutsideClick={() => { toggleAccessTypeMenu(false); }}
        >
          <div className={css(styles.practiceUserMenuContainer)}>
            {/* --- Practice Admin --- */}
            <div
              className={css(styles.practiceUserMenuItem, el.accessType === 'Practice Admin' && styles.practiceUserMenuItemActive)}
              onClick={() => {
                toggleAccessTypeMenu(false);
                updateAccessType('Practice Admin', idt);
              }}
            >
              Practice Admin
            </div>
            {/* --- Practice Manager --- */}
            <div
              className={css(styles.practiceUserMenuItem, el.accessType === 'Practice Manager' && styles.practiceUserMenuItemActive)}
              onClick={() => {
                toggleAccessTypeMenu(false);
                updateAccessType('Practice Manager', idt);
              }}
            >
              Practice Manager
            </div>
          </div>
        </PopupMenu>
      </div>
    </div>
  );
};

PracticeUserCard.displayName = 'PracticeUserCard';
PracticeUserCard.defaultProps = {
  disableMemberTypeSelection: false
};
export default PracticeUserCard;
